import React from 'react';
import block from 'bem-cn-lite';

import './ColumnResizeHandle.scss';

const b = block('column-resize-handle');

export const columnResizeDraggingClass = `${b()}_dragging`;

interface ColumnResizeHandleProps {
    onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
}

export const ColumnResizeHandle = ({onPointerDown}: ColumnResizeHandleProps) => (
    <div
        className={b()}
        aria-hidden
        onPointerDown={onPointerDown}
        onMouseDown={(event) => event.stopPropagation()}
        onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
        }}
    />
);